import { render, staticRenderFns } from "./PromptModal.vue?vue&type=template&id=b18f1540&scoped=true"
import script from "./PromptModal.vue?vue&type=script&lang=js"
export * from "./PromptModal.vue?vue&type=script&lang=js"
import style0 from "./PromptModal.vue?vue&type=style&index=0&id=b18f1540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f1540",
  null
  
)

export default component.exports